<template>
  <section
    class="call-plaque relative flex h-18 w-full max-w-110 min-w-0 items-stretch rounded-16 bg-bg-base-bg2 shadow-overlay"
    :class="{
      'h-auto min-h-18': isCompact,
    }"
  >
    <div class="flex min-w-0 flex-1 flex-col justify-center gap-1 py-2 pl-4 pr-1.5">
      <div class="flex min-w-0 items-center gap-1">
        <span class="inline-flex h-5 w-5 shrink-0 items-center justify-center overflow-hidden rounded-full">
          <contact-avatar
            class="origin-center scale-[0.833]"
            :contact="contact"
            :name="primaryName"
            :size="24"
          />
        </span>
        <p
          class="truncate text-body-m-15-22 text-fg-base-fg3"
          :title="primaryName"
        >
          {{ primaryName }}
        </p>
      </div>
      <div class="flex min-w-0 items-center gap-1">
        <span class="shrink-0 text-label-r-13-18 text-fg-base-fg22">
          {{ $t('common.incomingFrom') }}
        </span>
        <span class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-bg-base-bg6">
          <wui-icon
            name="phoneM"
            class="h-3! w-3! text-fg-base-fg22"
          />
        </span>
        <span
          class="truncate text-body-m-15-22 text-fg-base-fg3"
          :title="fromName"
        >{{ fromName }}</span>
      </div>
    </div>
    <div
      class="flex shrink-0 items-center gap-1.5 self-stretch pl-2 pr-3"
      :class="{
        'gap-1 px-2': isCompact,
      }"
    >
      <slot name="answer" />
      <wui-btn
        data-test="pickup-call-notification-item-close-button"
        variant="neut"
        state="alpha"
        class="shrink-0 rounded-8! px-2! text-body-m-14-20! text-fg-base-fg10!"
        @click="emit('close')"
      >
        {{ $t('common.hideNotification') }}
      </wui-btn>
    </div>
  </section>
</template>

<script setup lang="ts">
import { WuiBtn, WuiIcon } from '@wui/common-library'
import { computed } from 'vue'

import { useStoreContacts } from '@/entities/contact'
import { ContactAvatar } from '@/entities/contact-avatar'

import { NotifyEventData } from '@/shared/components/notifications'
import { CallNotificationType } from '@/shared/composables/calls-notifications'

const props = defineProps<{
  event: NotifyEventData
  type: CallNotificationType
  isCompact?: boolean
}>()

const emit = defineEmits<{
  (event: 'close'): void
}>()

const { findByInternalNumber } = useStoreContacts()

const primaryName = computed(() => props.event.targetName || props.event.target)

const fromName = computed(() => props.event.fromName || props.event.from)

const contact = computed(() => {
  const number = props.type === 'self-pickup'
    ? props.event.from
    : props.event.target
  return number ? findByInternalNumber(number) : undefined
})
</script>
